import React from 'react';
import styles from './SkillsColumn.module.css';

interface SkillsColumnProps {
  title: string;
  skills: string[];
}

export const SkillsColumn: React.FC<SkillsColumnProps> = ({
  title,
  skills,
}) => {
  return (
    <div className={styles.skillsColumn}>
      <h3 className={styles.columnTitle}>{title}</h3>
      <ul className={styles.skillsList}>
        {skills.map((skill, index) => (
          <li key={`${skill}-${index}`} className={styles.skillItem}>
            <span>{skill}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
